import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'bioconnect-ui-app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {}
